import { useState, useEffect } from "react";
import Sign from "./components/Sign";
import Dashboard from "./components/Dashboard";
import "./App.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) setIsLoggedIn(true);
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
  };

  return (
    <>
      {/* HEADER */}
      <header className="header">
  <div className="logo">Insta Emi</div>

  {/* DESKTOP NAV */}
  <nav className="desktop-nav">
    {!isLoggedIn ? (
      <>
        <a href="https://www.winpace-solution.co.in/about-3">About Us</a>
        <a href="https://share.google/jVoN1qhvTahmhiLiZ">Contact Us</a>
        <span className="nav-logo"><img src={require("./assets/form-logo.png")} alt="navlogo" /></span>
      </>
    ) : (
      <button className="logout-btn" onClick={handleLogout}>
        <img src={require("./assets/logout.png")} alt="logout" />
      </button>
    )}
  </nav>

  {/* MOBILE ACTION */}
  <div className="mobile-actions">
    {!isLoggedIn ? (
      <div className="menu-icon" onClick={() => setMenuOpen(true)}>
        ☰
      </div>
    ) : (
      <button className="logout-btn mobile-only" onClick={handleLogout}>
        <img src={require("./assets/logout.png")} alt="logout" />
      </button>
    )}
  </div>
</header>

      {/* MOBILE SLIDE MENU */}
      {!isLoggedIn && menuOpen && (
        <div className="mobile-menu">
          <div className="mobile-menu-header">
            <span>Menu</span>
            <button onClick={() => setMenuOpen(false)}>✖</button>
          </div>
          <div className="mob-menu-wrap">
            <span className="nav-logo"><img src={require("./assets/form-logo.png")} alt="navlogo" /></span>
            <a href="https://www.winpace-solution.co.in/about-3">About Us</a>
            <a href="https://share.google/jVoN1qhvTahmhiLiZ">Contact Us</a>
          </div>
        </div>
      )}

      {/* PAGE CONTENT */}
      {!isLoggedIn ? <Sign onLogin={handleLogin} /> : <Dashboard />}
    <footer className="footer">
      Copyright <a href="#">Winpace Solution Pvt. Ltd.</a> 2026
    </footer>
    </>
  );
}

export default App;
